const readWishlist = () => {
  try {
    const raw = document.cookie.match('(^|;) ?wishlist=([^;]*)(;|$)');
    const values = raw ? JSON.parse(raw[2]) : [];
    return Array.isArray(values) ? values.filter(v => v && v.handle && v.var).map(v => ({...v, id: String(v.id), var: String(v.var)})) : [];
  } catch { return []; }
};
let wishlistArray = readWishlist();
const setAttribute = () => {
  document.querySelectorAll('.wishlist_link').forEach(link => {
    link.classList.toggle('active', wishlistArray.length > 0);
    const bubble = link.querySelector('.wishlist-bubble');
    if (bubble) { bubble.classList.toggle('hidden', !wishlistArray.length); bubble.textContent = wishlistArray.length ? String(wishlistArray.length) : ''; }
  });
  const page = document.querySelector('[data-wanna-wishlist-page]');
  if (!page) return;
  const populated = wishlistArray.length > 0;
  const heading = page.querySelector('#page-wishlist-head'), empty = page.querySelector('#page-wishlist-empty-head'), link = page.querySelector('#page-wishlist-link');
  if (heading) heading.style.display = populated ? 'block' : 'none';
  if (empty) empty.style.display = populated ? 'none' : 'block';
  if (link) link.style.display = populated ? 'none' : 'inline-flex';
};

class wishlistBtn extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.setAttribute('role', 'button');
    this.tabIndex = 0;
    this.syncVariant();
    this.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); this.click(); }
    });
    this.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      wishlistArray = readWishlist();
      this.syncVariant();
      const id = String(this.dataset.var);
      const saved = wishlistArray.some(value => value.var === id);
      const next = saved ? wishlistArray.filter(value => value.var !== id) : [...wishlistArray, {id: String(this.dataset.id), handle: this.dataset.handle, var: id}];
      document.cookie = `wishlist=${JSON.stringify(next)}; max-age=2592000; path=/; SameSite=Lax`;
      wishlistArray = readWishlist();
      setAttribute();
      document.querySelectorAll('wishlist-btn').forEach(button => button.syncVariant?.());
      if (saved && !wishlistArray.some(value => value.var === id) && this.closest('[data-wanna-wishlist-page]')) this.closest('li.grid__item')?.remove();
    });
  }
  syncVariant() {
    const row = this.closest('[data-wishlist-variant]');
    const card = this.closest('wanna-collection-card');
    const product = this.closest('product-info');
    const input = product?.querySelector('form[action*="/cart/add"] [name="id"]');
    const variant = row?.dataset.wishlistVariant || card?.variant?.id || input?.value || this.dataset.var;
    if (variant) this.dataset.var = String(variant);
    const active = wishlistArray.some(value => String(value.var) === this.dataset.var);
    this.classList.toggle('active', active);
    this.setAttribute('aria-pressed', String(active));
    const title = card?.config?.productTitle || card?.querySelector('.card__heading')?.textContent.trim() || product?.querySelector('h1')?.textContent.trim();
    if (title) this.setAttribute('aria-label', title);
  }
}
if (!customElements.get('wishlist-btn')) customElements.define('wishlist-btn', wishlistBtn);

async function loadWishlist() {
  const page = document.querySelector('[data-wanna-wishlist-page]');
  if (!page || page.dataset.wishlistLoaded) return;
  page.dataset.wishlistLoaded = 'true';
  const grid = page.querySelector('#product-grid');
  if (!grid) return;
  wishlistArray = readWishlist();
  setAttribute();
  const entries = [...wishlistArray];
  let failed = false;
  const items = await Promise.all(entries.map(async (entry, index) => {
    try {
      let handle = entry.handle;
      const root = window.Shopify?.routes?.root || '/';
      if (handle.startsWith('/products/')) handle = root + handle.slice(1);
      const url = new URL(handle, location.origin);
      if (url.origin !== location.origin || !url.pathname.includes('/products/')) throw new Error('Invalid wishlist URL');
      url.searchParams.set('variant', entry.var);
      url.searchParams.set('view', 'wishlist');
      const response = await fetch(url.href);
      if (!response.ok) throw new Error('Wishlist request failed');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const item = doc.querySelector('li.grid__item');
      if (!item) throw new Error('Wishlist product unavailable');
      item.dataset.wishlistVariant = entry.var;
      item.querySelectorAll('[id]').forEach(node => {
        const oldId = node.id, newId = `${oldId}-saved-${index}`;
        node.id = newId;
        item.querySelectorAll('[for], [form], [aria-labelledby], [aria-describedby], [aria-controls], [data-modal]').forEach(ref => {
          for (const attribute of ['for', 'form', 'aria-labelledby', 'aria-describedby', 'aria-controls', 'data-modal']) {
            const value = ref.getAttribute(attribute);
            if (value) ref.setAttribute(attribute, value.split(' ').map(token => token === oldId ? newId : token === '#'+oldId ? '#'+newId : token).join(' '));
          }
        });
      });
      return item;
    } catch (error) { failed = true; console.warn('Wishlist item could not be loaded', error); return null; }
  }));
  const saved = readWishlist();
  grid.replaceChildren(...items.filter((item, index) => item && saved.some(entry => entry.var === entries[index].var)));
  grid.setAttribute('aria-busy', 'false');
  if (failed) {
    const error = document.createElement('p');
    error.setAttribute('role', 'alert');
    error.textContent = page.dataset.loadError;
    grid.after(error);
  }
}
const startWishlist = () => { setAttribute(); loadWishlist(); };
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startWishlist, {once: true});
else startWishlist();
document.addEventListener('shopify:section:load', startWishlist);
